import { useSharedGlobalState } from './useSharedGlobal';
export const usePermission = () => {
    const { checkActionMap } = useSharedGlobalState();
    return (permissionCode) => !!checkActionMap(permissionCode);
};
